import { RequestOptions } from './request-options';

export class UserProfileRequest extends RequestOptions {
    Id_User: number;
    Description: string;
    Id_Profile: number;
    FullName: string;
    IsShowCal: number;
    IsCalcCal: number;
    CalorificValuePerDay: number;
    ProteinsPerDay: number;
    FatsPerDay: number;
    CarbohydratesPerDay: number;
    PortionWeight: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/user-profile-request.ts